import { render, staticRenderFns } from "./ReporteComensales.vue?vue&type=template&id=d27222a6"
import script from "./ReporteComensales.vue?vue&type=script&lang=js"
export * from "./ReporteComensales.vue?vue&type=script&lang=js"
import style0 from "./ReporteComensales.vue?vue&type=style&index=0&id=d27222a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports